

import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Unit 12',
    id: 'SB5-V2-U12-P91-E1',
    audio: 'img/FriendsPlus/Page91/Audio/audio-e1-p91.mp3',
    video: '',
    component: DesignUnderLine,
    exerciseKey: 'img/FriendsPlus/Page91/E1/Key/answerKey.png',
    titleQuestion: [{ num: '1', title: 'Listen and check (✓).  <headphone name="115" src="img/FriendsPlus/Page91/Audio/tieude-e1-p91.mp3"></headphone>  ' }],
    totalInput: 3,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page91/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page91/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page91/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page91/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page91/E1/5.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page91/E1/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page91/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page91/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page91/E1/9.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page91/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page91/E1/11.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page91/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page91/E1/13.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page91/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page91/E1/15.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page91/E1/16.jpg' },
      ],
    ],
  },


  2: {
    unit: 'Unit 12',
    id: 'SB5-V2-U12-P91-E2',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    recorder: true,
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page91/E2/1.jpg' },
      ]
    ]
  },
  3: {
    unit: 'Unit 12',
    id: 'SB5-V2-U12-P91-E3',
    audio: '',
    video: '',
    component: D1,
    padding: '0 0 0 5px',
    exerciseKey: 'img/FriendsPlus/Page91/E3/Key/answerKey.png',
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page91/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page91/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page91/E3/3.jpg', input: true, answer: "and " },
        { url: 'img/FriendsPlus/Page91/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page91/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page91/E3/6.jpg', input: true, answer: "but " },
        { url: 'img/FriendsPlus/Page91/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page91/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page91/E3/9.jpg', input: true, answer: "and" },
        { url: 'img/FriendsPlus/Page91/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page91/E3/11.jpg' },
      ],

    ]
  },
  4: {
    unit: 'Unit 12',
    id: 'SB5-V2-U12-P91-E4',
    audio: '',
    video: '',
    component: D1,
    padding: '0 0 0 5px',
    exerciseKey: 'img/FriendsPlus/Page91/E3/Key/answerKey.png',
    titleImage: '',
    hideBtnFooter: true,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page91/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page91/E4/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page91/E4/3.jpg' },
        { url: 'img/FriendsPlus/Page91/E4/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page91/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page91/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page91/E4/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page91/E4/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page91/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page91/E4/10.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page91/E4/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page91/E4/12.jpg' },
      ],


    ]
  },





}
export default json;
